import Header from "./bundles/common/header/components/Header";
import { Footer } from "./bundles/common/footer/components/Footer";
import { ToastContainer } from "react-toastify";

import AppRoutes from "./AppRoutes";

function App() {
  return (
    <>
      <ToastContainer
        hideProgressBar={false}
        newestOnTop={false}
        rtl={false}
        position="top-right"
        autoClose={5000}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="app-shell">
        <Header />
        <main id="main-content">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;